import { render, staticRenderFns } from "./Produccion.vue?vue&type=template&id=76084970&"
import script from "./Produccion.vue?vue&type=script&lang=js&"
export * from "./Produccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports